import React, { useEffect, useState } from 'react';
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from '../../../../_metronic/_partials/controls';
import Table, {
	dateFormatter,
	buttonsStyle	
} from '../../../components/tables/table';
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog';
import { getSpecialDays, deleteSpecialDay, changeStatusSpecialDay } from '../../../../api/specialDay';
import { Button, Tooltip } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { alertError, alertSuccess } from '../../../../utils/logger';
import { useHistory } from 'react-router-dom';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import { shallowEqual, useSelector } from 'react-redux';
import { getNonEmpty } from '../../../../utils/helpers';
import { SERVER_URL } from '../../../../api';
import PreviewDialog from '../../../components/dialogs/PreviewDialog';

function getData(specialDays) {
	let data = [];
	const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

	for (let i = 0; i < specialDays.length; ++i) {
		const elem = {};
		elem.img = specialDays[i].imageURL;
		elem.name = getNonEmpty(specialDays[i].fullName);
		elem.createdAt = specialDays[i].createdAt;
		elem.id = specialDays[i]._id;
		elem.active = specialDays[i].active;
		elem.shortName = getNonEmpty(specialDays[i].shortName);
		elem.day = specialDays[i].day;
		elem.month = specialDays[i].month && monthNames[specialDays[i].month-1];
		data = data.concat(elem);
	}
	return data;
}

export default function SpecialDaysPage() {
	const [data, setData] = useState([]);
	const [specialDayId, setSpecialDayId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [refresh, setRefresh] = useState(false);
	const [openPreviewDialog, setOpenPreviewDialog] = useState(false)
	const [previewImage, setPreviewImage] = useState(null)
	const history = useHistory();
	const user = useSelector((store) => store.authentication?.user, shallowEqual)

	function imageFormatter(cell) {
		return (cell && cell !== '') ? (
		  <img 
			src={SERVER_URL + '/' + cell} 
			alt="specialDay" 
			style={{ width: '50px', height: '50px' }} 
			onClick={() => {
			  setPreviewImage(cell)
			  setOpenPreviewDialog(true)
			}}/>
		) : (
		  <div/>
		);
	  }

	function buttonFormatter(cell) {
		const elem = data.find(item => item.id === cell)
		return (
			<>
				<Tooltip title='Edit'>
					<Button
						style={buttonsStyle}
						size='small'
						onClick={() => history.push('/edit-specialDay/' + cell)}>
						<EditIcon />
					</Button>
				</Tooltip>
				{user?.role.includes('admin') && <>
					<Tooltip title={elem?.active ? "Disable" : "Enable"}>
						<Button
							style={buttonsStyle} size="small"
							onClick={() => {
								setSpecialDayId(elem)
								setOpenConfirmDialog(1)
							}}>
							{elem?.active ? <ToggleOffIcon/> : <ToggleOnIcon style={{ color: 'red' }} />}
						</Button>
					</Tooltip>
					<Tooltip title='Delete'>
						<Button
							style={buttonsStyle}
							size='small'
							onClick={() => {
								setSpecialDayId(cell);
								setOpenConfirmDialog(2);
							}}>
							<DeleteIcon />
						</Button>
					</Tooltip>
				</>}
			</>
		);
	}

	const columns = [
		{ dataField: 'img', text: 'Image', sort: false, formatter: imageFormatter },
		{ dataField: 'name', text: 'Full name', sort: true },
		{ dataField: 'shortName', text: 'Short name', sort: true },
		{ dataField: 'day', text: 'Day', sort: true },
		{ dataField: 'month', text: 'Month', sort: true },
		{
			dataField: 'createdAt',
			text: 'Created at',
			formatter: dateFormatter,
			sort: true,
		},
		{ dataField: 'id', text: '', formatter: buttonFormatter },
	];

	useEffect(() => {
		getSpecialDays()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({ error: error, customMessage: 'Could not get specialDays.' });
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title='SpecialDays list'>
					<CardHeaderToolbar>
						<button
							type='button'
							className='btn btn-primary'
							onClick={() => history.push('/edit-specialDay')}>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<PreviewDialog
						title={'Preview image'}
						open={openPreviewDialog}
						setOpen={setOpenPreviewDialog}
						src={previewImage ? `${SERVER_URL}/${previewImage}` : null}
					/>
					<ConfirmDialog
						title={`Are you sure you want to ${specialDayId?.active ? 'disable' : 'enable'} this specialDay?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusSpecialDay(specialDayId.id, !specialDayId?.active)
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({ title: `${specialDayId?.active ? 'Disabled!' : 'Enabled!'}`, customMessage: `SpecialDay ${specialDayId?.active ? 'disabled' : 'enabled'} successfully` })
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({ error: error, customMessage: `Could not ${specialDayId?.active ? 'disable' : 'enable'} specialDay.` })
								});
						}}
					/>
					<ConfirmDialog
						title={'Are you sure you want to remove this specialDay?'}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteSpecialDay(specialDayId)
								.then((res) => {
									if (res.status === 204 || res.status === 200) {
										alertSuccess({
											title: 'Deleted!',
											customMessage: 'SpecialDay removed successfully.',
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: 'Could not remove specialDay.',
									});
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
